import {
    room,
    Video,
    switchVideo,
    vb,
    privacyMode,
    deviceManager,
    CONV_STORAGE,
    hideSideMenu,
    cameraEnabledIcon,
    lobby,
    cameraOptionsPreferences,
    isElectron,
    getFrameRate,
    getIdealResolution,
    buttonSpam,
    screenShare
} from '../libs/roomnew';
import {
    createVirtualBackgroundEffect
} from '../features/virtual-background';
import { disableSimlucastLayers, getLayers } from '../features/simulcast/Layers';
import { getLocalKinoTrack, storeLocalTrack } from '../features/base/tracks/functions';
import { MEDIA_TYPE } from '../features/base/tracks/constants';
export default class VirtualBackground {

    constructor() {
        this.virtualBg = {};
        this.blurIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g xmlns="http://www.w3.org/2000/svg" fill="#032836"><path d="m101.993 170.862c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#032836" data-original="#454045" style="" class=""/><path d="m23.537 178.988c-12.978 0-23.537 10.558-23.537 23.536 0 12.979 10.559 23.537 23.537 23.537s23.537-10.559 23.537-23.537-10.558-23.536-23.537-23.536z" fill="#032836" data-original="#454045" style="" class=""/><path d="m309.476 154.167c-26.665 0-48.358 21.693-48.358 48.358s21.693 48.358 48.358 48.358c26.664 0 48.357-21.693 48.357-48.358s-21.693-48.358-48.357-48.358z" fill="#032836" data-original="#454045" style="" class=""/><ellipse cx="202.525" cy="202.525" rx="48.358" ry="48.358" transform="matrix(.973 -.23 .23 .973 -41.113 51.949)" fill="#032836" data-original="#454045" style="" class=""/><path d="m309.476 261.117c-26.665 0-48.358 21.693-48.358 48.358s21.693 48.358 48.358 48.358c26.664 0 48.357-21.693 48.357-48.358 0-26.664-21.693-48.358-48.357-48.358z" fill="#032836" data-original="#454045" style="" class=""/><path d="m410.007 170.862c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#032836" data-original="#454045" style="" class=""/><path d="m488.463 226.062c12.979 0 23.537-10.559 23.537-23.537s-10.559-23.537-23.537-23.537-23.537 10.559-23.537 23.537 10.558 23.537 23.537 23.537z" fill="#032836" data-original="#454045" style="" class=""/><ellipse cx="202.525" cy="309.475" rx="48.358" ry="48.358" transform="matrix(.707 -.707 .707 .707 -159.514 233.85)" fill="#032836" data-original="#454045" style="" class=""/><path d="m101.993 277.813c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#032836" data-original="#454045" style="" class=""/><path d="m23.537 285.938c-12.978 0-23.537 10.559-23.537 23.538 0 12.978 10.559 23.537 23.537 23.537s23.537-10.559 23.537-23.537c0-12.979-10.558-23.538-23.537-23.538z" fill="#032836" data-original="#454045" style="" class=""/><path d="m410.007 277.813c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#032836" data-original="#454045" style="" class=""/><path d="m488.463 285.938c-12.979 0-23.537 10.559-23.537 23.537s10.559 23.537 23.537 23.537 23.537-10.558 23.537-23.536c0-12.979-10.559-23.538-23.537-23.538z" fill="#032836" data-original="#454045" style="" class=""/><path d="m309.476 133.656c17.459 0 31.662-14.204 31.662-31.663s-14.203-31.663-31.662-31.663-31.663 14.204-31.663 31.663 14.204 31.663 31.663 31.663z" fill="#032836" data-original="#454045" style="" class=""/><circle cx="410.007" cy="101.993" r="31.663" fill="#032836" data-original="#454045" style="" class=""/><path d="m101.993 378.344c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#032836" data-original="#454045" style="" class=""/><path d="m410.007 378.344c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#032836" data-original="#454045" style="" class=""/><path d="m101.993 70.331c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#032836" data-original="#454045" style="" class=""/><circle cx="309.476" cy="23.537" r="23.537" fill="#032836" data-original="#454045" style="" class=""/><path d="m309.476 378.344c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.662-14.204 31.662-31.663-14.203-31.663-31.662-31.663z" fill="#032836" data-original="#454045" style="" class=""/><circle cx="309.476" cy="488.463" r="23.537" fill="#032836" data-original="#454045" style="" class=""/><path d="m202.524 133.656c17.459 0 31.663-14.204 31.663-31.663s-14.204-31.663-31.663-31.663-31.663 14.204-31.663 31.663 14.204 31.663 31.663 31.663z" fill="#032836" data-original="#454045" style="" class=""/><path d="m202.524 47.074c12.979 0 23.537-10.559 23.537-23.537.001-12.978-10.558-23.537-23.537-23.537-12.978 0-23.537 10.559-23.537 23.537.001 12.978 10.559 23.537 23.537 23.537z" fill="#032836" data-original="#454045" style="" class=""/><path d="m202.524 378.344c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#032836" data-original="#454045" style="" class=""/><path d="m202.524 464.926c-12.978 0-23.537 10.559-23.537 23.537s10.559 23.537 23.537 23.537c12.979 0 23.537-10.559 23.537-23.537s-10.558-23.537-23.537-23.537z" fill="#032836" data-original="#454045" style="" class=""/></g></g></svg>`;
        this.blurIconNotification = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g xmlns="http://www.w3.org/2000/svg" fill="#fff"><path d="m101.993 170.862c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#fff" data-original="#454045" style="" class=""/><path d="m23.537 178.988c-12.978 0-23.537 10.558-23.537 23.536 0 12.979 10.559 23.537 23.537 23.537s23.537-10.559 23.537-23.537-10.558-23.536-23.537-23.536z" fill="#fff" data-original="#454045" style="" class=""/><path d="m309.476 154.167c-26.665 0-48.358 21.693-48.358 48.358s21.693 48.358 48.358 48.358c26.664 0 48.357-21.693 48.357-48.358s-21.693-48.358-48.357-48.358z" fill="#fff" data-original="#454045" style="" class=""/><ellipse cx="202.525" cy="202.525" rx="48.358" ry="48.358" transform="matrix(.973 -.23 .23 .973 -41.113 51.949)" fill="#fff" data-original="#454045" style="" class=""/><path d="m309.476 261.117c-26.665 0-48.358 21.693-48.358 48.358s21.693 48.358 48.358 48.358c26.664 0 48.357-21.693 48.357-48.358 0-26.664-21.693-48.358-48.357-48.358z" fill="#fff" data-original="#454045" style="" class=""/><path d="m410.007 170.862c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#fff" data-original="#454045" style="" class=""/><path d="m488.463 226.062c12.979 0 23.537-10.559 23.537-23.537s-10.559-23.537-23.537-23.537-23.537 10.559-23.537 23.537 10.558 23.537 23.537 23.537z" fill="#fff" data-original="#454045" style="" class=""/><ellipse cx="202.525" cy="309.475" rx="48.358" ry="48.358" transform="matrix(.707 -.707 .707 .707 -159.514 233.85)" fill="#fff" data-original="#454045" style="" class=""/><path d="m101.993 277.813c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#fff" data-original="#454045" style="" class=""/><path d="m23.537 285.938c-12.978 0-23.537 10.559-23.537 23.538 0 12.978 10.559 23.537 23.537 23.537s23.537-10.559 23.537-23.537c0-12.979-10.558-23.538-23.537-23.538z" fill="#fff" data-original="#454045" style="" class=""/><path d="m410.007 277.813c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#fff" data-original="#454045" style="" class=""/><path d="m488.463 285.938c-12.979 0-23.537 10.559-23.537 23.537s10.559 23.537 23.537 23.537 23.537-10.558 23.537-23.536c0-12.979-10.559-23.538-23.537-23.538z" fill="#fff" data-original="#454045" style="" class=""/><path d="m309.476 133.656c17.459 0 31.662-14.204 31.662-31.663s-14.203-31.663-31.662-31.663-31.663 14.204-31.663 31.663 14.204 31.663 31.663 31.663z" fill="#fff" data-original="#454045" style="" class=""/><circle cx="410.007" cy="101.993" r="31.663" fill="#fff" data-original="#454045" style="" class=""/><path d="m101.993 378.344c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#fff" data-original="#454045" style="" class=""/><path d="m410.007 378.344c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#fff" data-original="#454045" style="" class=""/><path d="m101.993 70.331c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#fff" data-original="#454045" style="" class=""/><circle cx="309.476" cy="23.537" r="23.537" fill="#fff" data-original="#454045" style="" class=""/><path d="m309.476 378.344c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.662-14.204 31.662-31.663-14.203-31.663-31.662-31.663z" fill="#fff" data-original="#454045" style="" class=""/><circle cx="309.476" cy="488.463" r="23.537" fill="#fff" data-original="#454045" style="" class=""/><path d="m202.524 133.656c17.459 0 31.663-14.204 31.663-31.663s-14.204-31.663-31.663-31.663-31.663 14.204-31.663 31.663 14.204 31.663 31.663 31.663z" fill="#fff" data-original="#454045" style="" class=""/><path d="m202.524 47.074c12.979 0 23.537-10.559 23.537-23.537.001-12.978-10.558-23.537-23.537-23.537-12.978 0-23.537 10.559-23.537 23.537.001 12.978 10.559 23.537 23.537 23.537z" fill="#fff" data-original="#454045" style="" class=""/><path d="m202.524 378.344c-17.459 0-31.663 14.204-31.663 31.663s14.204 31.663 31.663 31.663 31.663-14.204 31.663-31.663-14.204-31.663-31.663-31.663z" fill="#fff" data-original="#454045" style="" class=""/><path d="m202.524 464.926c-12.978 0-23.537 10.559-23.537 23.537s10.559 23.537 23.537 23.537c12.979 0 23.537-10.559 23.537-23.537s-10.558-23.537-23.537-23.537z" fill="#fff" data-original="#454045" style="" class=""/></g></g></svg>`;
        this.net = null;
        this.enabled = true;
        this.effectPlaying = false;
        this.videoElement;
        this.imageBackgroundEnable = false;
        this.effect = false;
        this.selectedEffect = false;

        this.maxImageSize = 3145728; //3MB
        this.maxDimensions = {
            width: 4096,
            height: 2400
        };
        this.optionsBtn = null;
        this.btnLabel = "Virtual Background";
        this.modalTitleText = 'Virtual Background';
        this.modalSubTitleText = 'Select an image to set as a virtual background';
        this.backgrounds = [{
                id: 1,
                type: "none",
                location: "",
                name: "None"
            },
            {
                id: 2,
                type: "blur",
                amount: 14,
                location: this.blurIcon,
                name: "Blur"
            },{
                id: 3,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-kino.jpeg`,
                name: "Kino Office"
            },{
                id: 4,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-1.jpg`,
                name: "Office 1"
            },{
                id: 5,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-2.jpg`,
                name: "Office 2"
            },{
                id: 6,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-3.jpg`,
                name: "Office 3"
            },{
                id: 7,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Offices/office-4.jpg`,
                name: "Office 4"
            },{
                id: 8,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/green-room.jpg`,
                name: "Green Room"
            },
            {
                id: 9,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/home-bg.jpg`,
                name: "White Room"
            },{
                id: 10,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Nature/nature-1.jpg`,
                name: "Nature 1"
            },{
                id: 11,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Nature/nature-2.jpg`,
                name: "Nature 2"
            },{
                id: 12,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Nature/nature-3.jpg`,
                name: "Nature 3"
            },{
                id: 13,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Halloween/halloween-1.jpg`,
                name: "Halloween 1"
            },{
                id: 14,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Halloween/halloween-2.jpg`,
                name: "Halloween 2"
            },{
                id: 15,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Christmas/christmas-1.jpg`,
                name: "Christmas 1"
            },{
                id: 16,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Christmas/christmas-2.jpg`,
                name: "Christmas 2"
            },{
                id: 17,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Christmas/christmas-3.jpg`,
                name: "Christmas 3"
            },{
                id: 18,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Thanksgiving/thanksgiving-1.jpg`,
                name: "Thanksgiving 1"
            },{
                id: 19,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Thanksgiving/thanksgiving-2.jpg`,
                name: "Thanksgiving 2"
            },{
                id: 20,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Diwali/diwali-1.jpg`,
                name: "Diwali 1"
            },{
                id: 21,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Diwali/diwali-2.jpg`,
                name: "Diwali 2"
            },{
                id: 22,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Diwali/diwali-3.jpg`,
                name: "Diwali 3"
            },{
                id: 23,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Hanukka/hanukka-1.jpg`,
                name: "Hanukka 1"
            },{
                id: 24,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Hanukka/hanukka-2.jpg`,
                name: "Hanukka 2"
            },{
                id: 25,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Holidays/Hanukka/hanukka-3.jpg`,
                name: "Hanukka 3"
            },{
                id: 26,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Party/party-1.jpg`,
                name: "Party 1"
            },{
                id: 27,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Party/party-2.jpg`,
                name: "Party 2"
            },{
                id: 28,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Party/party-3.jpg`,
                name: "Party 3"
            },{
                id: 29,
                type: "image",
                location: `${isElectron ? '../../' : ''}/images/virtual-background/Party/party-4.jpg`,
                name: "Party 4"
            }
        ];
        //preview
        this.isPreviewing = false;
        this.previewSize = {
            width: 1280,
            height: 720
        };
        this.previewVideo;
        this.resumeEffectOnUnmute = false;
        this.cameraTrack = null;
        this.streamEffect = undefined;
        this.fromLobby=false;
        this.shouldDisableHighRes=false;

    };

    onLoad() {};
    addOptionButton() {
        var sc = this;
        sc.enabled = true;
        if (sc.optionsBtn !== null) {
            return
        }
        sc.optionIcon = $('<div/>', {
            class: "option-icon",
            id: "vbgIcon",
            html: sc.blurIcon,
        });
        sc.optionName = $('<div/>', {
            class: "option-name",
            id: "option-name-vbg",
            html: sc.btnLabel,
        });
        sc.optionAction = $('<div/>', {
            class: "option-action",
            id: "option-action-vbg",
            html: '',
        });
        sc.optionDescription = $('<div/>', {
            class: "option-description",
            html: [ sc.optionName, sc.optionAction],
        });
        sc.optionsBtn = $('<div/>', {
            class: 'option',
            id: 'virtualBackgroundOptionBtn',
            html: [sc.optionIcon, sc.optionDescription],
        }).on('click',function(){
            sc.showPreviewModal();
            hideSideMenu();
        });

        $("#option-list").find("#virtualBackgroundOptionBtn").remove();
        $("#option-list").append(sc.optionsBtn);
    };

    removeOptionButton() {
        var sc = this;
        sc.enabled = false;
        if (sc.optionsBtn !== null) {
            sc.optionsBtn.remove();
        }
        sc.optionsBtn = null;
        $("#kino-options-list").find("#virtualBackgroundOptionBtn").remove();
    };

    updateOriginalStream() {
        var vbg = this;
        try {
            vbg.changeStream(vbg.outputCanvas.captureStream(vbg.frameRate));

        } catch (e) {
            console.error("Error updating stream", e);
        }

    };

    async runEffect(track = null) {
        var vb = this;
        let options = null;
        this.shouldDisableHighRes = getIdealResolution() === 360;
        if (vb.effect) {
            options = {
                virtualSource: vb.effect.type == "image" ? vb.effect.location : null,
                blurValue: vb.effect.type == "blur" ? vb.effect.amount : null,
                backgroundType: vb.effect.type
            };
        }
        if (options) {
            this.effectPlaying = true;
            let usingPrivacyBlur = privacyMode.enabled;
            try {
                if (this.streamEffect) {
                    this.streamEffect.stopEffect();
                    this.streamEffect = undefined;
                }
                if (track) {
                    //return modified stream
                    return this.modifyStream(track, options);

                } else {
                    if(this.cameraTrack){
                        this.cameraTrack.stream.getTracks().forEach(track => {
                            track.stop()
                        })
                    }

                    console.log(`Ideal resolution ${getIdealResolution()},framerate ${getFrameRate()}`)
                    let currentVideoTrack = getLocalKinoTrack(MEDIA_TYPE.VIDEO);
                    let currentMuted = currentVideoTrack ? currentVideoTrack.isMuted() :true;
                    let deviceId = currentVideoTrack ? currentVideoTrack.getDeviceId() : deviceManager.lastUsedCamera();
                    deviceManager.captureCamera(deviceId,{
                        resolution: getIdealResolution(),
                        frameRate: getFrameRate()
                    }).then(async (cameraTrack) => {
                        if(currentVideoTrack.stream){
                            currentVideoTrack.stream.getTracks().forEach(track => {
                                track.stop()
                            })
                        }
                        let modifiedTrack = await this.modifyStream(cameraTrack,options);
                        await room.replaceTrack(currentVideoTrack, modifiedTrack)
                        storeLocalTrack(modifiedTrack);
                        if(currentMuted){
                            this.unmuteCameraIcon();
                        }
                        if(currentVideoTrack._originalStream){
                            currentVideoTrack._originalStream.getTracks().forEach(track => {
                                track.stop()
                            })
                        }
                        // getLayers();
                        if(this.shouldDisableHighRes){
                            disableSimlucastLayers([2]);
                        }
                        console.warn(`Successfully replaced Virtual Background track using deviceId ${deviceId}`);
                        // CONV_STORAGE.updateVideoStream(room.myUserId());
                        if(usingPrivacyBlur && privacyMode.streamEffect){
                            privacyMode.streamEffect.stopEffect();
                            privacyMode.streamEffect=undefined;
                        }
                    }).catch(error => {
                        this.stopEffect(true);
                        console.error(`Privacy mode capture camera error`, error);
                    });
                }



            } catch (error) {
                console.error("Error playing effect", error)
            }
        }
        return false;
    };
    async modifyStream(track, options) {
        this.streamEffect = await createVirtualBackgroundEffect(options);
        track._originalStream=track.stream;
        let vbStream = this.streamEffect.startEffect(track.stream);
        track.stream = vbStream;
        track.track = track.stream.getTracks()[0];
        return track;
    };
    unmuteCameraIcon(){
        try {
            // $('#room-mute-video').attr('data-original-title', 'Camera On');
            // $('#room-mute-video').attr('title', 'Camera On');
            // $('#room-mute-video').tooltip('hide');
            $('#room-mute-video').html(cameraEnabledIcon);
            room.setLocalParticipantProperty('video_muted', false);
            Video.cameraMuted(room.myUserId(),false);
        } catch (error) {
            console.error("unmute camera ",error)
        }

    }

    stopEffect(isError=false, fromLobby=false) {
        var vbg = this;
        if(!fromLobby){
            vbg.effectPlaying = false;
            vbg.effect = false;
        }
        try {
            if(!isError){
                let currentVideoTrack=getLocalKinoTrack(MEDIA_TYPE.VIDEO);
                if(currentVideoTrack){

                    if(!currentVideoTrack.isMuted()){
                        if(currentVideoTrack._originalStream){
                            console.log("found original stream when stopping effect",currentVideoTrack._originalStream);
                            currentVideoTrack._originalStream.stop();
                        }
                        switchVideo(currentVideoTrack.getDeviceId());
                      }
                }else{
                    switchVideo(deviceManager.lastUsedCamera());
                }
            }
            if (this.streamEffect) {
                this.streamEffect.stopEffect();
                this.streamEffect._inputVideoElement.pause();
                this.streamEffect._inputVideoElement.srcObject=null;
                this.streamEffect._inputVideoElement.load();
                this.streamEffect = undefined;
            }

        } catch (error) {
            console.error(error);
        }
    };

    onSetMySpace() {
        var vbg = this;
        if(buttonSpam.isSpam(vbg.startEffectBtn.attr('id'), false)){
            return;
        }
        if (Video.isSharingScreen) {
            vb.errorMessage.html('You need to stop sharing screen to enable virtual background');
            return;
        }
        vbg.stopPreview();
        vbg.startEffectBtn.prop('disabled', true);
        if(vbg.fromLobby){
            if(!vbg.effect || vbg.effect.id != vbg.selectedBackground.id){
                lobby.onVirtualBackgroundSet(vbg.selectedBackground);
            }
            vbg.hidePreviewModal();
            if(vbg.effectPlaying && lobby.virtualBackgroundIconContainer){
                lobby.virtualBackgroundIconContainer.addClass('enabled');
            }else if (!vbg.effectPlaying && lobby.virtualBackgroundIconContainer){
                lobby.virtualBackgroundIconContainer.removeClass('enabled');
            }
            return;
        }
        vbg.hidePreviewModal();
        if (vbg.selectedBackground) {
            vbg.effect = vbg.selectedBackground;
            vbg.runEffect();
            if (privacyMode.enabled) {
                privacyMode.enabled = false;
                privacyMode.vbEffect = null;
                privacyMode.updateUIButtons();
            }
        } else {

            if(getLocalKinoTrack(MEDIA_TYPE.VIDEO).isMuted()) {
                this.cameraTrack.stream.getTracks().forEach(track => {
                    track.stop()
                })
            }

            if (!privacyMode.enabled) {
                vbg.stopEffect();
            } else {
                privacyMode.vbEffect = null;
                vbg.effectPlaying = false;
            }
        }
    };

    stopPreview() {
        console.log("Stoppping preview")
        this.isPreviewing = false;
        if (this.previewEffect) {
            this.previewEffect.stopEffect();
            this.previewEffect._inputVideoElement.pause();
            this.previewEffect._inputVideoElement.srcObject=null;
            this.previewEffect._inputVideoElement.load();

            this.previewEffect = undefined;
        }
        if (this.previewStream) {
            this.previewVideo.srcObject = this.previewStream;
        }
    };
    async runPreview() {
        var vb = this;
        //console.trace("run preview");
        vb.startEffectBtn.prop('disabled', true);
        clearTimeout(vb.changeVBTimeout);
        let options = null;
        if (vb.selectedBackground && vb.selectedBackground.type == "image") {
            options = {
                type: "SET_VIRTUAL_BACKGROUND",
                virtualSource: vb.selectedBackground.location,
                backgroundType: "image"
            };
        } else if (vb.selectedBackground && vb.selectedBackground.type == "blur") {
            //render blur
            options = {
                type: "SET_VIRTUAL_BACKGROUND",
                virtualSource: null,
                blurValue: vb.selectedBackground.amount,
                backgroundType: null
            };


        } else {
            this.previewVideo.srcObject = this.previewStream;
        }

        if (options) {
            this.isPreviewing = true;
            this.previewEffect = await createVirtualBackgroundEffect(options);
            if (!this.cameraTrack) {
                console.log("Camera track not set, getting local video")
                this.cameraTrack = getLocalKinoTrack(MEDIA_TYPE.VIDEO);
            }
            // console.error("CAMERA TRACK ON RUN PREVIEW",this.cameraTrack);
            let effectStream = this.previewEffect.startEffect(this.cameraTrack.stream);
            this.previewVideo.srcObject = effectStream;
            if(!(vb.selectedBackground && vb.selectedBackground.id == vb.effect.id)){
                // console.log('enters here as well')
                vb.changeVBTimeout = setTimeout(() => {
                    vb.startEffectBtn.prop('disabled', false);
                }, 300);
            }
        }
    };

    showPreviewModal(videoTrack=false, fromLobby=false) {
        var vb = this;

        if(vb.modal && vb.modal.hasClass('minimized-modal')){
            Video.minimizedContent.maximizeModal('virtualBackgroundModal');
            return;
        }
        if(vb.modal)return;
        vb.previewVideo = document.createElement('video');
        vb.previewVideo.setAttribute('playsinline', true);
        vb.previewStream=undefined;
        try {
            vb.cameraTrack=videoTrack ? videoTrack : Video.isSharingScreen ? screenShare.cameraStream : getLocalKinoTrack(MEDIA_TYPE.VIDEO);
            if(vb.cameraTrack){
                if(vb.cameraTrack.isMuted()){
                    deviceManager.captureCamera(vb.cameraTrack.getDeviceId()).then(cameraTrack=>{
                        vb.cameraTrack=cameraTrack;
                        vb.previewStream=vb.cameraTrack.stream;
                        vb.previewVideo.srcObject=vb.previewStream;
                    }).catch(error=>{
                        console.error("failed to find selected camera",error);
                    })
                }else{
                  if(privacyMode.enabled || vb.effectPlaying){
                      console.log(`Privacymode active ${privacyMode.enabled}, vb effect playing ${vb.effectPlaying}`)
                    vb.previewStream=vb.cameraTrack._originalStream;
                  }else{
                    console.log("Using original camera stream")
                    vb.previewStream=vb.cameraTrack.stream;
                  }
                  vb.previewVideo.srcObject=vb.previewStream;
                }

                // console.error("Preview Stream",vb.previewStream);
            }else{
                deviceManager.captureCamera(deviceManager.lastUsedCamera()).then(cameraTrack=>{
                    vb.cameraTrack=cameraTrack;
                    vb.previewStream=cameraTrack.stream;
                    vb.previewVideo.srcObject=vb.cameraTrack.stream;
                }).catch(error=>{
                    console.error("failed to find selected camera",error);
                })
            }

         } catch (error) {

         }
        vb.previewVideo.oncanplay = () => {
            vb.previewVideo.play();
        };

        vb.previewVideo.onplaying = () => {};
        vb.videoContainer = $("<div/>", {
            class: `local-video skeleton ${!cameraOptionsPreferences.camera_flip ? 'flipVideoX' : ''}`,
            html: [vb.previewVideo]
        });
        let videoPreviewContainer = $("<div/>", {
            class: "local-video-virtual-background-container ignore-drag",
            html: vb.videoContainer
        });
        let backgroundBoxContent = $("<div/>", {
            class: "bg-option content",
            html: "+"
        }).css({
            fontSize: "35px",
            color: "#032836"
        })
        let backgroundSelectBox = $("<div/>", {
            class: "options",
            html: backgroundBoxContent
        });
        this.backgroundOptionsList = $("<div/>", {
            class: "option-list-virtual-background-container mt-3",
            html: backgroundSelectBox
        }).on('wheel',(event)=>{
            event.preventDefault();
            this.backgroundOptionsList.animate({scrollLeft:this.backgroundOptionsList.scrollLeft() + event.originalEvent.deltaY},50);
        });
        this.errorMessage = $("<span/>", {
            class: "error_kino text-center ignore-drag"
        });
        // let modalBody = $("<div/>", {
        //     class: 'modal-body mx-auto p-0',
        //     html: [videoPreviewContainer, this.backgroundOptionsList, this.errorMessage]
        // });
        let cameraIsOffAlert = $(`<div />`, {
            class: 'local-video-virtual-background-container ignore-drag',
            style: 'height: auto; margin-top: 5px;',
            html: `<div class="errors">${this.showErrorMessage('Activating virtual background will turn on your camera')}</div>`
        })
        let modalBody = $("<div/>", {
            class: 'modal-body mx-auto p-0',
            html: (vb.cameraTrack && vb.cameraTrack.isMuted())
                ? [videoPreviewContainer, this.backgroundOptionsList, this.errorMessage, cameraIsOffAlert]
                : [videoPreviewContainer, this.backgroundOptionsList, this.errorMessage]
        });

        let cancelVbBtn = $('<button/>',{
            class: "btn btn-primary kino-btn-secondary",
            type: "button",
            html: "cancel"
            }).on('click',e=>{
                if(room && !Video.isSharingScreen && getLocalKinoTrack(MEDIA_TYPE.VIDEO) && getLocalKinoTrack(MEDIA_TYPE.VIDEO).isMuted()) {
                    this.cameraTrack.mute()
                }
                this.hidePreviewModal()
                this.fromLobby=false;
        });
        vb.startEffectBtn = $('<button/>', {
            class: "btn btn-primary kino-btn-primary",
            id: 'set-virtual-background',
            type: "button",
            disabled: true,
            html: "Set my space"
        }).on('click', this.onSetMySpace.bind(this));

        let modalFooter = $("<div/>", {
            class: "modal-footer border-0",
            html: [cancelVbBtn, vb.startEffectBtn]
        });

        let minimizeModalBtn = $('<button/>',{
            class: "close-button-modal-kino minimize-button",
            type: "button",
            html: `<i class="fas fa-window-minimize"></i>`
        }).on('click', ()=>{
            Video.minimizedContent.minimizeModal('virtualBackgroundModal', vb.blurIconNotification);
        });

        let closeModalBtn = $("<button/>", {
            class: "close-button-modal-kino",
            type: "button",
            html: `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19
            0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34
            120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12
            3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12
            3.12-8.19 0-11.31L193.94 256z"></path>
        </svg>`
        }).on('click', e => {
            // muting camera track when user doesnt activate virtual background
            if(room && getLocalKinoTrack(MEDIA_TYPE.VIDEO) && getLocalKinoTrack(MEDIA_TYPE.VIDEO).isMuted()) {
                this.cameraTrack.mute()
            }
            this.hidePreviewModal()
            this.fromLobby=false;
        });
        let modalTitle = $('<h4/>',{
            class: 'modal-title text-center ignore-drag',
            id: 'virtualBackgroundModalTitle',
            html: vb.modalTitleText
        });
        // let modalSubTitle = $('<span/>',{
        //     class: 'ignore-drag',
        //     html: vb.modalSubTitleText
        // })
        let modalHeader = $("<div/>", {
            class: "modal-header modal-header-kino mb-3",
            html: [modalTitle, !this.fromLobby ? minimizeModalBtn : '', closeModalBtn]
        });

        let modalContent = $("<div/>", {
            class: 'modal-content',
            html: [modalHeader, modalBody, modalFooter]
        });

        let modalDialog = $("<div/>", {
            class: "modal-dialog modal-dialog-centered modal-inside-kino",
            role: "document",
            html: modalContent
        });
        vb.modal = $("<div/>", {
            class: "modal modal-inside-kino fade",
            id: "virtualBackgroundModal",
            style: `${fromLobby ? 'height: 100% !important': ''}`,
            tabindex: "-1",
            role: "dialog",
            'aria-labelledby': "virtualBackgroundModal",
            'aria-hidden': "true",
            'data-backdrop': "static",
            'data-keyboard': "false",
            html: modalDialog
        }).on('keyup', (e) => {
            if (e.keyCode == 27) {
                vb.hidePreviewModal();
             }
        });
        $('body').append(vb.modal);
        vb.listAvailableBackgrounds();
        vb.modal.modal('show');
        if (vb.selectedBackground) {
            vb.runPreview();
        }
    };

    hidePreviewModal() {
        let vb = this;
        vb.fromLobby=false;
        if (vb.modal != null) {
            vb.cameraTrack=undefined;
            vb.previewStream=undefined;
            vb.modal.modal('hide');
            vb.stopPreview();
            //card 584
            if(vb.previewVideo){
                vb.previewVideo.pause();
                vb.previewVideo.srcObject=null;
                vb.previewVideo.load();
                vb.previewVideo.remove();

            }

            //end card 584
            setTimeout(() => {
                this.modal.remove();
                this.modal = null;
            }, 500);

        }
    };

    listAvailableBackgrounds() {
        var vb = this;
        this.backgroundOptionsList.html("");
        console.log(vb.selectedBackground)
        if(vb.selectedBackground && vb.selectedBackground.id === vb.effect && vb.effect.id){
            vb.startEffectBtn.prop('disabled', true);
        }else if(!vb.selectedBackground && vb.effectPlaying){
            vb.startEffectBtn.prop('disabled', false);
        }
        this.backgrounds.map(bg => {
            let boxContent = $("<div/>", {
                class: `bg-option content`,
                html: bg.type == "image" ? `<img src="${bg.location}" height="68">` : bg.type == "none" ? bg.name : bg.location
            })
            let box = $("<div/>", {
                class: `options ${vb.selectedBackground && vb.selectedBackground.id == bg.id ? "selected" : !vb.selectedBackground && bg.type == "none" ? "selected" : ""}`,
                html: boxContent
            }).css({
                order: bg.id <= 2 ? `3` : `4`
            }).on('click', function () {
                if(vb.effect.id == bg.id || bg.id == 1 && !vb.effectPlaying){
                    vb.startEffectBtn.prop('disabled', true);
                }
                if (vb.selectedBackground && vb.selectedBackground.id == bg.id) {
                    return
                }
                vb.backgroundOptionsList.find(".options").removeClass("selected");
                vb.errorMessage.html('');
                if (bg.type == "none") {
                    if(!vb.selectedBackground && !vb.effectPlaying){
                        return;
                    }
                    if(vb.selectedBackground && vb.selectedBackground.id == bg.id){
                        return;
                    }
                    $(this).addClass("selected");
                    // vb.stopPreview();
                    vb.selectedBackground = false;
                    clearTimeout(vb.changeVBTimeout);
                    if(bg.id == 1 && vb.effectPlaying && vb.effect && vb.effect.id != 1){
                        // console.log('It enters here');
                        vb.startEffectBtn.prop('disabled', false);
                    }
                } else {
                    $(this).addClass("selected");
                    vb.stopPreview();
                    vb.selectedBackground = bg;
                    vb.runPreview();
                }


            });
            this.backgroundOptionsList.append(box);
        });
        // var element = this.backgroundOptionsList.find(".options.selected");
        console.log("selected",this.selectedBackground);
        if(this.selectedBackground && this.selectedBackground.id){
            const move=this.selectedBackground.id*69;
            console.log("Scrolling",move)
            setTimeout(() => {
                this.backgroundOptionsList.animate({scrollLeft:move},50);
            }, 300);
        }
        // smooth scroll to element and align it at the bottom
        vb.addNewBackgroundBox();
    };

    addNewBackgroundBox() {
        var vb = this;
        let backgroundInput = $('<input/>', {
            type: "file",
            style: "display:none",
            accept: "image/x-png,image/jpeg"
        }).on('change', vb.handleSelectedImage.bind(vb));
        let boxContent = $("<div/>", {
            class: `bg-option content`,
            html: [`+`]
        }).css({
            fontSize: "35px",
            color: "#032836"
        }).on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            backgroundInput.click();
        });

        let box = $("<div/>", {
            class: `options`,
            html: [boxContent, backgroundInput]
        }).css({
            order: "2"
        })
        vb.backgroundOptionsList.prepend(box);
    };

    handleSelectedImage(e) {
        var vb = this;
        vb.errorMessage.html('');
        if (e.target.files.length) {
            let file = e.target.files[0];
            if (!file.type.match('image.*')) {
                vb.errorMessage.html('Selected file is not a image type');
                return;
            }
            console.log(file);
            let imageReader = new FileReader();
            imageReader.onload = function (image) {
                if (vb.validateImage(image)) {
                    let htmlImage = new Image;
                    htmlImage.onload = function () {
                        if (htmlImage.width < 600 || htmlImage.height < 300) {
                            vb.errorMessage.html(`Please choose a bigger size image`);
                        } else if (htmlImage.width > vb.maxDimensions.width || htmlImage.height > vb.maxDimensions.height) {
                            vb.errorMessage.html(`Please choose a smaller size image`);
                        } else {
                            vb.errorMessage.html('');
                            vb.addBackground(image.target.result, file.name);
                            vb.listAvailableBackgrounds();
                        }
                    };
                    htmlImage.src = image.target.result;


                }

            };
            imageReader.readAsDataURL(file);

        };

    };

    validateImage(image) {
        console.log("validating image", image.total);
        if (image.total > this.maxImageSize) {
            this.errorMessage.html(`Maximum allowed size is ${(this.maxImageSize/1024)/1024}MB`)
            return false;
        }
        return true;
    };

    addBackground(image, name) {
        this.backgrounds.unshift({
            id: this.backgrounds.length + 1,
            name: name,
            location: image,
            type: "image"
        });
    };

    unload() {
        if (this.effectPlaying) {
            this.stopEffect(true);
        }
        try {
            this.hidePreviewModal();
        } catch (error) {
            console.log("Virtual background unload error", error)
        }
    };

    showErrorMessage(message) {
        return `
            <div class="alert mb-0 custom-alert-primary mt-3" role="alert">
                <div class="row align-items-center">
                    <div class="col-auto font-md pr-0 black-color">
                        <i class="fas fa-exclamation-triangle h1" style="font-weight: 900"></i>
                    </div>
                    <div class="col black-color">
                        <p class='m-0'>${message}</p>
                    </div>
                </div>
            </div>
        `
    }

};
